import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-right\"><defs><style type=\"text/css\">@font-face { font-family: element-icons; src: url(\"chrome-extension://moombeodfomdpjnpocobemoiaemednkg/fonts/element-icons.woff\") format(\"woff\"), url(\"chrome-extension://moombeodfomdpjnpocobemoiaemednkg/fonts/element-icons.ttf \") format(\"truetype\"); }\n</style></defs><path d=\"M408.96 800.96l-33.92-33.92L630.048 512 375.04 256.96l33.92-33.92L697.952 512z\" p-id=\"11570\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/m-common/svg/md-icon/arrow-right.svg
// module id = +HSX
// module chunks = 317